<template>
	<div class="admin-store__search">
		<InputSearch actionBtn v-model="filter.name" @search="this.requestStoreGroups(filter)" />
	</div>
	<div class="table-card">
		<div class="table-wrap">
			<table class="table table--default" v-if="storeGroups?.items.length">
				<thead class="table__head">
					<tr class="table__row">
						<td class="table__col">Наименование группы</td>
						<td class="table__col">Магазины</td>
						<td class="table__col"></td>
						<td class="table__col"></td>
						<td class="table__col"></td>
						<td class="table__col"></td>
						<td class="table__col"></td>
						<td class="table__col"></td>
					</tr>
					<tr class="table__margin">
						<td colspan="100%"></td>
					</tr>
				</thead>
				<tbody class="table__body">
					<template v-for="(item) in storeGroups.items" :key="item">
						<tr class="table__row">
							<td class="table__col">
								<span class="table__col-label">Наименование группы</span>
								<span class="table__col-cont">{{ item.name }}</span>
							</td>
							<td class="table__col">
								<span class="table__col-label">Магазины</span>
								<span class="table__col-cont">
									<span class="cutcontent">{{getStoreString(item.shops) || 'Не найдено' }}</span>
								</span>
							</td>
							<td class="table__col"></td>
							<td class="table__col"></td>
							<td class="table__col"></td>
							<td class="table__col"></td>
							<td class="table__col"></td>
							<td class="table__col table__col--btn ">
								<div class="table__btns">
									<button class="icon-btn icon-btn--edit" @click="selectedGroup = item, ShowAddEditStorePopup = true">Редактировать</button>
									<button class="icon-btn icon-btn--delete" @click="selectedGroup = item, ShowDeleteStorePopup = true">Удалить</button>
								</div>
							</td>
						</tr>
						<tr class="table__margin">
							<td colspan="100%"></td>
						</tr>
					</template>
				</tbody>
			</table>
			<div v-else class="table-card__empty">Группы магазинов не найдены</div>
		</div>
		<div class="pagination">
			<vue-awesome-paginate
				v-if="storeGroups?.countTotal > filter.limit"
				:total-items="+storeGroups?.countTotal"
				:items-per-page="filter.limit"
				:max-pages-shown="3"
				v-model="currentPage"
				:on-click="changePage" />
		</div>
	</div>
	<transition name="modal">
		<AddEditStorePopup v-if="ShowAddEditStorePopup" :change="true" :group="selectedGroup" @refreshList="this.requestStoreGroups(filter)" @close="ShowAddEditStorePopup = false" />
	</transition>

	<transition name="modal">
		<DeleteStorePopup v-if="ShowDeleteStorePopup" :group="selectedGroup" @refreshList="this.requestStoreGroups(filter)" @close="ShowDeleteStorePopup = false"  />
	</transition>
	<PageLoader v-if="isLoading"/>
</template>

<script>
import DeleteStorePopup from "@/components/sections/Store/DeleteStorePopup.vue";
import AddEditStorePopup from "@/components/sections/Store/AddEditStorePopup.vue";
import InputSearch from "@/components/base/utils/formElements/InputSearch.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import {mapActions, mapGetters} from "vuex";

export default {
	name: "StoreTable",
	components: {
		AddEditStorePopup,DeleteStorePopup,InputSearch,PageLoader
	},
	async created() {
		await this.requestStoreGroups(this.filter)
	},
	data() {
		return {
			ShowAddEditStorePopup: false,
			ShowDeleteStorePopup: false,
			selectedGroup: {},
			currentPage: 1,
			filter: {
				name: '',
				offset: 0,
				limit: 10
			}
		}
	},
	methods: {
		getStoreString(shops) {
			return shops.reduce((acc,item,index) => acc += `${item.name}${shops.length != index + 1 ? ', ' : "."}`,'')
		},
		async changePage(value) {
			this.filter.offset =  (value - 1) * this.filter.limit || 0
			await this.requestStoreGroups(this.filter)
		},
		...mapActions({
			requestStoreGroups: 'storeGroups/requestStoreGroups',
		}),
	},
	computed: {
		...mapGetters({
			storeGroups: 'storeGroups/getStoreGroups',
			isLoading: 'isLoading',
		})
	},
}
</script>


